export enum EntityState {
  View = 1,
  Edit = 2,
  New = 3  
}
